import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../config/AuthContext";
import "../css/home.css";
import Login from "../newView/Login";
import {useNavigate, useParams} from "react-router-dom";
import {Layout} from 'antd';
import {Content} from "antd/es/layout/layout";
import AppHeader from "./components/AppHeader";
import AppBreadcrumb from "./components/AppBreadcrumb";
import AppFooter from "./components/AppFooter";
import AppHomeRoutes from "./routes/AppHomeRoutes";

const Home = () => {
    const {isLoggedIn, userId, user, setBreadCrumb} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();
    const [dades, setDades] = (useState<string>())

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user)
        checkDades(id);
        setBreadCrumb([{nom: 'Home', nav: '/home'}], true);
    }, [id]);

    async function checkDades(id: any) {
        setLoading(true);
        //await setDades(await GetProjecteId(id));
        //await setLoading(false);
    }

    if (isLoggedIn) {
        return (
            <>
                <Layout style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
                    <AppHeader/>
                    <Content style={{padding: '0 48px', flex: '1 0 auto'}}>
                        <AppBreadcrumb/>
                        <Layout style={{padding: '24px 0', background: '#fff', borderRadius: '8px'}}>
                            <AppHomeRoutes/>
                        </Layout>
                    </Content>
                    <AppFooter/>
                </Layout>
            </>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Home;
